module.exports = __webpack_public_path__ + "Simple-Line-Icons.73a932562a1e31470346.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = ../../../../../src/fonts/Simple-Line-Icons.svg?v=2.4.0
// module chunks = 2